import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-hint" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_icon = _resolveComponent("b-icon")!
  const _component_b_tooltip = _resolveComponent("b-tooltip")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_b_tooltip, {
      position: "is-right",
      class: "is-info",
      size: "is-large",
      multilined: ""
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          innerHTML: _ctx.$t(_ctx.messageKey)
        }, null, 8, _hoisted_2)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_b_icon, {
          icon: "information-outline",
          size: "is-small",
          class: "has-text-grey-light"
        })
      ]),
      _: 1
    })
  ]))
}